module.exports = __webpack_public_path__ + "static/img/pcerror.4d4882e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcerror.png
// module id = uh3J
// module chunks = 0